<template>
  <div :style="{ width: width +'px', height: height + 'px' }" class="videoLayer">
    <div class="head">
      <div class="img fl"><img src="./back.png" width="35" height="28" alt=""></div>
      <div class="title fl">1-1上课注意事项</div>
      <div class="userInfo fr">
        <div class="news fl">
          <router-link to="/notice">
            <img src="../../assets/news.png" width="26" height="26" alt="">
          </router-link>
        </div>
        <div class="portrait fl">
          <router-link to="/userInfo">
            <img src="../../assets/portrait.png" width="30" height="30" alt="">
          </router-link>
        </div>
      </div>
    </div>
    <div :style="{ height: ( height - 100 ) + 'px' }" class="content">
      <div :style="{ width: ( width - 400 ) + 'px' }" class="video fl">
        <videoPlayer></videoPlayer>
        <div class="videoRight">
          <ul>
            <li @click="videoTab(0)" :class=" videoIndex === 0 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/1.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/2.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">回放</div>
            </li>
            <li @click="videoTab(1)" :class=" videoIndex === 1 || videoIndex === 4 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/3.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/4.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">问答</div>
            </li>
            <li @click="videoTab(2)" :class=" videoIndex === 2 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/5.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/6.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">笔记</div>
            </li>
            <li @click="videoTab(3)" :class=" videoIndex === 3 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/7.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/8.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">评论</div>
            </li>
            <li @click="videoTab(5)" :class=" videoIndex === 5 ? 'choice':'' ">
              <div class="img">
                <img src="Tab-img/11.png" width="40" height="40" class="img1" alt="">
                <img src="Tab-img/12.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">互动</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="container fr">
        <chapter v-if="videoIndex === 0" :height="(height - 100)"></chapter>
        <question ref="question" @changIndex="changIndex" v-if="videoIndex === 1" :height="(height - 100)"></question>
        <answer ref="answer" @changIndex="changIndex" v-if="videoIndex === 4" :height="(height - 100)"></answer>
        <notes v-if="videoIndex === 2" :height="(height - 100)"></notes>
        <comments v-if="videoIndex === 3" :height="(height - 100)"></comments>
        <interactive v-if="videoIndex === 5" :height="(height - 100)"></interactive>
      </div>
    </div>
    <div v-if="subjectFalse" class="subjectLayer">
      <subject></subject>
    </div>
  </div>
</template>

<script>
  import videoPlayer from '@/components/liveLayer/video/video'
  import chapter from '@/components/liveLayer/chapter/chapter'
  import question from '@/components/liveLayer/question/question'
  import answer from '@/components/liveLayer/answer/answer'
  import notes from '@/components/liveLayer/notes/notes'
  import comments from '@/components/liveLayer/comments/comments'
  import subject from '@/components/liveLayer/subject/subject'
  import interactive from '@/components/liveLayer/interactive/interactive'

  export default {
    components: {
      videoPlayer,
      chapter,
      question,
      answer,
      notes,
      comments,
      subject,
      interactive
    },
    data () {
      return {
        width: 0,
        height: 0,
        videoIndex: 5,
        subjectFalse: false
      }
    },
    mounted () {
      this.width = document.documentElement.clientWidth
      this.height = document.documentElement.clientHeight
    },
    created () {
      this.$store.dispatch('hide')
    },
    methods: {
      videoTab (index) {
        this.videoIndex = index
      },
      changIndex (index) {
        this.videoIndex = index
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .videoLayer {
    width: 100%;
    height: 100%;

    .head {
      height: 99px;
      padding: 0 60px;
      background-color: #fff;
      border-bottom: 1px solid #dcdcdc;
      overflow: hidden;

      .img {
        width: 35px;
        height: 28px;
        margin: 36px 20px 0 0;
        cursor: pointer;
      }

      .title {
        font-size: 20px;
        color: #7a7a7a;
        line-height: 100px;
      }

      .userInfo {
        height: 40px;
        width: 160px;
        margin: 30px 0 0 0;

        .news {
          width: 79px;
          height: 26px;
          border-right: 1px solid #adadad;
          margin-top: 7px;
          cursor: pointer;

          img {
            display: block;
            margin: 2px auto 0;
          }
        }

        .portrait {
          width: 80px;
          height: 40px;
          cursor: pointer;

          img {
            display: block;
            margin: 5px auto 0;
          }
        }
      }
    }

    .content {
      width: 100%;

      .video {
        height: 100%;
        background-color: #000;
        position: relative;

        .videoRight {
          width: 80px;
          height: 100%;
          background-color: #1c1f21;
          position: absolute;
          right: 0;
          top: 0;
        }

        ul {
          height: 450px;
          width: 80px;
          position: relative;
          left: 0;
          top: 50%;
          margin: -225px 0 0 0;

          li {
            height: 90px;
            text-align: center;
            color: #fff;
            overflow: hidden;
            cursor: pointer;
            position: relative;

            .name {
              margin-top: 55px;
            }

            .img {
              position: absolute;
              left: 20px;
              top: 10px;
            }

            .img2 {
              display: none;
            }

            &.choice {
              background-color: #26292c;

              .img1 {
                display: none;
              }

              .img2 {
                display: block;
              }
            }

            &:hover {
              background-color: #26292c;

              .img1 {
                display: none;
              }

              .img2 {
                display: block;
              }
            }
          }
        }
      }

      .container {
        width: 400px;
        height: 100%;
        background-color: #fff;
      }
    }

    .subjectLayer {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 99;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/liveLayer/liveLayer.vue